import { render } from "./dialogDetail.vue?vue&type=template&id=2242718b&scoped=true"
import script from "./dialogDetail.vue?vue&type=script&lang=js"
export * from "./dialogDetail.vue?vue&type=script&lang=js"

import "./dialogDetail.vue?vue&type=style&index=0&id=2242718b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2242718b"]])

export default __exports__